const hasErrorData = (data) => {
    if (data.title && (data.price !== 0 || data.dealPrice !== 0) && data.weight !== 0 && data.dimensions && data.images.length > 0) {
        return false;
    }else {
        return true
    }
    
}

export default hasErrorData;